import React, { Component } from 'react'
import styles from './styles.css'

export interface TypingIndicatorProps {
  names: string[]
}

export default class TypingIndicator extends Component<TypingIndicatorProps> {
  public render() {
    const { names } = this.props
    let activity: string | null

    switch (names.length) {
      case 0:
        activity = null
        break

      case 1:
        activity = `${names[0]} is typing...`
        break

      case 2:
      case 3:
        activity = `${names.slice(0, -1).join(', ')} and ${names.slice(1)[0]} are typing...`
        break

      default:
        activity = `${names.length} people are typing...`
    }

    if (activity) {
      return (
        <div className={styles.row}>
          <div className={styles.typing}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
          </div>
          {activity}
        </div>
      )
    } else {
      return null
    }
  }
}
